import { Row, Button, Input, Space, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import classNames from 'classnames/bind';

import { useGetCustomers } from '../../../../apis';
import { ContentsLayout } from '../../../../components/layout';

import AddCustomerModal from '../modal';
import { columns } from './constants';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Customers = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const { data: customerData } = useGetCustomers();

  return (
    <>
      <ContentsLayout headTitle={'업체관리'}>
        <div className={cx('container')}>
          <Row align={'middle'} justify={'space-between'}>
            <Space align="center">
              <strong className={cx('search')}>검색</strong>
              <Input placeholder="업체명" onChange={(onChangeEvent) => setSearch(onChangeEvent.target.value)} />
            </Space>

            <Button onClick={() => setIsOpen((isPrev) => !isPrev)} type="primary">
              신규
            </Button>
          </Row>

          <Table
            size="small"
            dataSource={
              customerData?.filter((data) => {
                if (search === '') return data;
                return data.name.includes(search);
              }) || []
            }
            scroll={{
              x: 1280,
              y: 600,
            }}
            virtual
            rowKey="rid"
            onRow={(record) => {
              return {
                onClick: () => navigate(`/management/customers/detail/${record.rid}`),
              };
            }}
            pagination={false}
            columns={columns}
          />
        </div>
      </ContentsLayout>
      <AddCustomerModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default Customers;
